import { Component, ChangeDetectionStrategy } from '@angular/core';
import { AuthService } from '../../../core/auth/auth.service';
import { SnackbarService } from '../../../core/services/snackbar/snackbar.service';
import { catchError, of } from 'rxjs';
import { ConfirmDialogComponent } from 'src/app/shared/ui-components/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-consent-form',
  standalone: false,
  templateUrl: './consent-form.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./consent-form.component.scss'],
})
export class ConsentFormComponent {
  constructor(
    private authService: AuthService,
    private snackBarService: SnackbarService,
    private dialog: MatDialog
  ) {}

  onConfirm(): void {
    this.authService
      .submitUserConsent()
      .pipe(
        catchError((error) => {
          console.error('Error submitting consent:', error);
          this.snackBarService.showErrorMessage(
            'Failed to submit consent. Please try again later.'
          );
          return of(null);
        })
      )
      .subscribe(() => {
        this.snackBarService.showSuccessMessage(
          'Thank you for your consent! You can start tracking your carbon footprint now.'
        );

        this.authService.getActiveUser().subscribe({
          next: (user) => {
            if (user) {
              user.hasGivenConsent = true;
            }
          },
          error: (err) => console.error('Error fetching user data:', err),
        });
      });
  }

  onCancel() {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: 'Delete Profile',
        message: 'Are you sure you want to delete your profile?',
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
      },
    });
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.authService.deleteCurrentUser().subscribe({
          next: () => {
            this.snackBarService.showSuccessMessage(
              'Profile deleted successfully!'
            );
          },
          error: (err: any) => {
            this.snackBarService.showErrorMessage(
              'Failed to delete profile. Please try again.'
            );
          },
        });
      }
    });
  }
}
